import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useTenantQuery } from '@/hooks/useTenantQuery';

export function ElevatedWorkspaceBanner() {
  const { t } = useTranslation('navigation');
  const { activeTenantId, switchWorkspace } = useAuth();
  const [isExiting, setIsExiting] = useState(false);
  const resolvedTenantId = activeTenantId === null ? '' : activeTenantId;
  const tenantQuery = useTenantQuery(resolvedTenantId);
  const workspaceName =
    tenantQuery.data === undefined ? t('elevatedAccess.unknownWorkspace') : tenantQuery.data.name;

  async function exitWorkspace() {
    setIsExiting(true);
    try {
      await switchWorkspace({ scopeCode: 'platform', tenantId: null });
    } finally {
      setIsExiting(false);
    }
  }

  return (
    <div className="flex items-center gap-3 px-4 sm:px-6 md:px-8 py-2.5 bg-zooindigo text-zoowhite">
      <Icon name="ShieldAlert" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <span className="text-sm font-semibold">
          {t('elevatedAccess.label', { workspace: workspaceName })}
        </span>
        <span className="hidden sm:inline text-sm text-zoowhite/70">
          {' '}
          {t('elevatedAccess.description')}
        </span>
      </div>
      <Button
        variant="outline"
        onClick={exitWorkspace}
        isLoading={isExiting}
        className="shrink-0 bg-transparent border-zoowhite/40 text-zoowhite hover:bg-zoowhite/10"
      >
        {t('elevatedAccess.exit')}
      </Button>
    </div>
  );
}
